// src/api/search.ts
import type { SearchApiResponse } from "../types/SearchResult";

const SEARCH_API_URL =
  "https://api.ayesearch.com/api/search/";

export async function fetchWebSearch(
  query: string,
  limit: number = 20,
): Promise<SearchApiResponse> {
  const url = new URL(SEARCH_API_URL);

  url.searchParams.set("q", query);
  url.searchParams.set("limit", String(limit));

  const response = await fetch(url.toString(), {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Search API returned HTTP ${response.status}`);
  }

  const data = (await response.json()) as SearchApiResponse;

  // Preserve additional backend fields such as `domain_media`.
  // The old normalization rebuilt the object with only query/count/results
  // and silently removed crawler-backed favicon metadata.
  return {
    ...data,
    query:
      typeof data.query === "string"
        ? data.query
        : query,
    count:
      typeof data.count === "number"
        ? data.count
        : Array.isArray(data.results)
          ? data.results.length
          : 0,
    results: Array.isArray(data.results) ? data.results : [],
  };
}
